var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSh4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    width: 266,
    height: 177.5,
    viewBox: "0 0 266 177.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29",
    "data-name": "Group 29",
    transform: "translate(-1049.5 -2000)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "emotional_suffering",
    "data-name": "emotional suffering",
    transform: "translate(1182.5 2085)",
    fill: "#4c2750",
    fontSize: 64,
    fontFamily: "Oswald-Bold, Oswald",
    fontWeight: 700,
    letterSpacing: "-0.06em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -132.352,
    y: 0
  }, "EMOTIONAL"), /*#__PURE__*/React.createElement("tspan", {
    x: -127.392,
    y: 61
  }, "SUFFERING")), /*#__PURE__*/React.createElement("text", {
    id: "Shame_is_a_key_aspect_in_the",
    "data-name": "Shame is a key aspect in the",
    transform: "translate(1182.5 2024)",
    fill: "#1d1d1d",
    fontSize: 20,
    fontFamily: "Oswald-Medium, Oswald",
    fontWeight: 500,
    letterSpacing: "-0.03em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -112.98,
    y: 0
  }, "SHAME IS A KEY ASPECT IN THE")), /*#__PURE__*/React.createElement("text", {
    id: "of_survivors",
    "data-name": "of survivors",
    transform: "translate(1182.5 2171.5)",
    fill: "#1d1d1d",
    fontSize: 20,
    fontFamily: "Oswald-Medium, Oswald",
    fontWeight: 500,
    letterSpacing: "-0.03em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -54.2,
    y: 0
  }, "OF SURVIVORS")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSh4);
export default __webpack_public_path__ + "static/media/sh4.227fd4ca8409a1909409b5042435c40b.svg";
export { ForwardRef as ReactComponent };